import "./style.css";

export default class Header {
  static selector = ".header";

  constructor(block) {
    this.block = block;
    const menuBtn = this.block.querySelector("#menu-btn");
    menuBtn.addEventListener("click", this.onMenuBtnClick);

    const searchBox = this.block.querySelector(".iaee-search-input");
    searchBox.addEventListener("keyup", this.keySearch);

    this.loginButton = this.block.querySelector(".header__nav__login-button");
    this.mobileLoginButton = this.block.querySelector(
      ".header__menu__login-button"
    );

    this.prevScrollY = window.pageYOffset;
    this.overlay = document.querySelector("#overlay");
  }

  handleLoginButtonClick = () => {
    window.App.modals.login.open();
  };

  keySearch = () => {
  /*  
    var searchInput = jQuery('.iaee-search-input').val();
    searchInput = jQuery.trim(searchInput).length;
    if(searchInput !== 0){
     jQuery('.iaee-search-submit').css('z-index','99');
    } else{
     jQuery('.iaee-search-input').val('');
     jQuery('.iaee-search-submit').css('z-index','-999');
    }

    */
  }

  onScroll = () => {
    const currScrollY = window.pageYOffset;
    const navHeight = this.block.offsetHeight;

    if (Math.abs(this.prevScrollY - currScrollY) <= navHeight / 2) return;

    const collapse = currScrollY > this.prevScrollY && currScrollY > navHeight;
    this.block.classList.toggle("collapsed", collapse);

    this.prevScrollY = currScrollY;
  };

  onMenuBtnClick = () => {
    const shown = this.block.classList.toggle("show-menu");
  //  document.body.classList.toggle("no-scroll", shown);
  //  this.overlay.classList.toggle("no-display", !shown);
  };

  onReady = () => {
    if (this.loginButton) {
      this.loginButton.addEventListener("click", this.handleLoginButtonClick);
    }

    if (this.mobileLoginButton) {
      this.mobileLoginButton.addEventListener(
        "click",
        this.handleLoginButtonClick
      );
    }
    this.isOpen = false;
    var submitIcon = jQuery('.iaee-icon-search');
    var submitInput = jQuery('.iaee-search-input');
    var searchBox = jQuery('.iaee-search');
    var iaeeSearchto = jQuery('.iaeeSearchto');
    
    submitIcon.click(function(){
        if(typeof(this.isOpen) == 'undefined' || this.isOpen == false ){
          searchBox.addClass('iaee-search-open');
          iaeeSearchto.removeClass('noborder');
          iaeeSearchto.addClass('hasborder');
          this.isOpen = true;
          submitInput.focus();
        } else {
          searchBox.removeClass('iaee-search-open');
          iaeeSearchto.removeClass('hasborder');
          iaeeSearchto.addClass('noborder');
          this.isOpen = false;
        }
        return ; 
    });

  };

  onDestroy = () => {
    if (this.loginButton) {
      this.loginButton.removeEventListener(
        "click",
        this.handleLoginButtonClick
      );
    }

    if (this.mobileLoginButton) {
      this.mobileLoginButton.removeEventListener(
        "click",
        this.handleLoginButtonClick
      );
    }
  };
}
